<!-- Main Container -->
@if (storageGroup$ | async; as group) {
  <div class="layout-col full">
    <!-- Toolbar -->
    <mat-toolbar elderTheme color="primary" class="layout-row gap-md">
      <button mat-icon-button (click)="doClose($event)">
        <mat-icon>close</mat-icon>
      </button>
      <elder-header
        [header]="'storageGroups.storageGroup' | translate"
        [subheader]="'ID: ' + group.id"
      >
      </elder-header>
    </mat-toolbar>
    <!-- Main Tabs -->
    <mat-tab-group class="flex" animationDuration="0ms">
      <!-- Tab Overview -->
      <mat-tab label="{{ 'context.overview' | translate }}">
        <elder-basic-pane-layout class="full">
          <!-- General -->
          <elder-pane class="flex-30">
            <elder-pane-header>
              <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
              <elder-pane-actions>
                <button mat-icon-button [disabled]="!generalFrm.form.valid" (click)="save()">
                  <mat-icon>save</mat-icon>
                </button>
              </elder-pane-actions>
            </elder-pane-header>
            <elder-pane-content>
              <form #generalFrm="ngForm" class="layout-col gap-md flex">
                <div class="layout-row gap-md">
                  <div class="layout-col flex">
                    <div class="layout-row gap-md">
                      <mat-form-field floatLabel="always">
                        <mat-label>{{ 'context.orderReference' | translate }}</mat-label>
                        <input
                          matInput
                          name="orderReferenceNumber"
                          required
                          [ngModel]="group.orderReferenceNumber"
                          readonly
                        />
                      </mat-form-field>
                      <mat-form-field floatLabel="always">
                        <mat-label>{{ 'context.expectedWeight' | translate }}</mat-label>
                        <elder-quantity-input
                          name="expectedPackageWeight"
                          readonly
                          [(ngModel)]="group.expectedPackageWeight"
                        >
                        </elder-quantity-input>
                      </mat-form-field>
                    </div>
                    <div class="layout-row gap-md">
                      <mat-form-field floatLabel="always">
                        <mat-label>{{ 'context.longestItemDimensions' | translate }}</mat-label>
                        <elder-dimensions-input
                          name="longestItemDimensions"
                          readonly
                          [(ngModel)]="group.longestItemDimensions"
                        >
                        </elder-dimensions-input>
                      </mat-form-field>
                    </div>
                    <div class="layout-row gap-md">
                      <elder-audited-entity [audited]="group"></elder-audited-entity>
                    </div>
                  </div>
                </div>
              </form>
            </elder-pane-content>
          </elder-pane>
          <!-- Package Groups -->
          <elder-pane class="flex">
            <elder-pane-header>
              <elder-pane-title>{{ 'packageGroups.title' | translate }}</elder-pane-title>
            </elder-pane-header>
            <elder-pane-content>
              <app-package-group-table class="flex" [packageGroups]="group.packageGroups">
              </app-package-group-table>
            </elder-pane-content>
          </elder-pane>
        </elder-basic-pane-layout>
      </mat-tab>
      <!-- Packages -->
      <mat-tab label="{{ 'packages.title' | translate }}">
        <ng-template matTabContent>
          <app-package-browser
            class="flex"
            [storageGroupIdFilter]="group.id"
            [openDetailInDialog]="true"
          >
          </app-package-browser>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
}
